import React from 'react';
import Button from '../shared/Button';
import { DISCOUNTED_PENSION_PLAN_PRICE, PENSION_PLAN_PRICE } from '../../constants/constants';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import Text from '../shared/Text';
import { mp } from '../../constants/utils';

export const StyledFirstButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0px 20px;
`;

export const StyledSecondButton = css`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0px 20px;
  margin-bottom: 20px;
`;

export const StyledButtonA = styled.a`
  width: 250px;
  margin-bottom: 10px;
  text-decoration: none;
`;

export const StyledLink = styled(Link)`
  width: 250px;
  text-decoration: none;
`;

export default function PensionPlanCTA({
  referralId = 9999,
  withDiscount = false,
  origin = 'unknown',
}) {
  return (
    <>
      <StyledButtonA target="_blank" href="https://www.youtube.com/watch?v=dfs1OF0bSYk">
        <Button
          styles={StyledFirstButton}
          onClick={() => {
            mp('Referrals | CTA | PlanDeEjemplo');
          }}
          color="darkerGray"
        >
          <Text type="buttonText" color="white" bold>
            Ver plan de ejemplo
          </Text>
          {/* <Icon icon="playVideo" color="white" size={25} style={{ marginLeft: '10px' }} /> */}
        </Button>
      </StyledButtonA>
      <StyledLink
        to={
          '/retiro/contacto/5989130/' +
          (withDiscount
            ? `3b65300c-f2e0-4264-b413-e46c70835976/${referralId}`
            : 'c88927a2-f2a0-4a3d-9642-0463ca882121')
        }
      >
        <Button
          styles={StyledSecondButton}
          onClick={() => {
            mp('Referrals | CTA | Solicitar plan');
          }}
        >
          <Text type="buttonText" style={{ marginRight: '8px' }} color="white" bold>
            ${withDiscount ? DISCOUNTED_PENSION_PLAN_PRICE : PENSION_PLAN_PRICE}
          </Text>
          <Text type="buttonText" color="white" bold>
            Solicitar plan
          </Text>
        </Button>
      </StyledLink>
    </>
  );
}
